const prependZero = n => n < 10 ? `0${n}` : `${n}`;
export const dateToString = date => !date ? '' : `${date.getUTCFullYear()}-${prependZero(date.getUTCMonth() + 1)}-${prependZero(date.getUTCDate())}`;
//# sourceMappingURL=dateToString.js.map